export default ({
  GPNZ: 'GPNZ',
  GPAU: 'GPAU',
  DWNZ: 'DWNZ',
  DWAU: 'DWAU',
});
